/**
 * Remove squared button style
 *
 * @since Custom Theme 1.0
 */
/* global wp */
wp.domReady( function() {
	wp.blocks.unregisterBlockStyle( 'core/button', 'squared' );
} );
